<template>
  <div>
    <div class="row twofa-page">
      <div class="col-lg-12">
        <KTPortlet v-bind:title="$t('TWOFA.TFAUTH')">
          <template v-slot:toolbar> </template>
          <template v-slot:body>
            <b-alert
              show
              variant="warning"
              v-html="$t('HOME.DESC1')"
              v-if="!isTfa"
            ></b-alert>
            <b-alert
              show
              variant="warning"
              v-html="$t('HOME.DESC2')"
              v-if="!isTfa"
            ></b-alert>

            <b-alert v-if="!allowDisable" show variant="info">{{ $t("AUTH.MFA_ENROLLMENT.KEEP_ENABLED") }}</b-alert>
            <b-alert v-if="!canConfigure" show variant="info">{{ $t("AUTH.MFA_ENROLLMENT.REAUTHENTICATE") }}</b-alert>
            <div v-if="canConfigure" class="row table-filter">
              <div class="col-sm-6">
                <b-form-group
                  :label="$t('TWOFA.SEL_STATUS')"
                  label-for="select-status"
                >
                  <b-form-select
                    id="select-status"
                    v-model="status.selected"
                    :options="statusData"
                    value-field="value"
                    text-field="name"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-sm-6">
                <b-button
                  variant="primary"
                  @click="openModal()"
                  style="margin-top: 25px"
                >
                  {{ $t("COMMON.SAVE") }}
                </b-button>
              </div>
            </div>

            <!-- ----------disable modal------------- -->
            <b-modal
              ref="disableModal"
              :title="$t('TWOFA.DISABLE_TITLE')"
              @shown="onOtpModalShown('disable')"
              @hidden="onOtpModalHidden"
            >
              <b-container fluid>
                <p>1. {{ $t("TWOFA.DDEC1") }}</p>
                <p>2. {{ $t("TWOFA.DDEC2") }}</p>

                <b-row class="my-4">
                  <b-col sm="12">
		<div class="otp-center">
                    <label class="d-block mb-2">{{ $t("TWOFA.CHALLENGE") }}:</label>

                    <!-- OTP INPUTS -->
                    <div class="otp-wrap" @paste.prevent="onOtpPaste">
                      <input
                        v-for="(d, idx) in otpDigits"
                        :key="'disable-' + idx"
                        :ref="'otp-' + idx"
                        class="otp-input"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        autocomplete="one-time-code"
                        maxlength="1"
                        :value="otpDigits[idx]"
                        @input="onOtpInput($event, idx)"
                        @keydown="onOtpKeydown($event, idx)"
                        @focus="onOtpFocus(idx)"
                        :aria-label="$t('TWOFA.OTP_DIGIT', { digit: idx + 1 })"
                      />
                    </div>

                    <div v-if="otpError" class="otp-error mt-2">
                      {{ $t("VALIDATION.REQUIRED_FIELD") }}
                    </div>
		</div>
                  </b-col>
                </b-row>
              </b-container>

              <template v-slot:modal-footer>
                <b-button
                  variant="outline-secondary"
                  v-on:click="modalClose('disableModal')"
                >
                  {{ $t("COMMON.CANCEL") }}
                </b-button>
                <b-button variant="primary" v-on:click="disableTfa()">
                  {{ $t("COMMON.SAVE") }}
                </b-button>
              </template>
            </b-modal>

            <!-- ----------enable modal step 1------------- -->
            <b-modal
              ref="enableModal1"
              :title="$t('TWOFA.ENABLE_TITLE', { step: 1 })"
            >
              <b-container fluid>
                <p>
                  1. {{ $t("TWOFA.DEC1") }}
                  <a href="https://www.authy.com/download" target="_blank">{{
                    $t("TWOFA.AUTHY")
                  }}</a
                  >.
                </p>
                <p>2. {{ $t("TWOFA.DEC2") }}</p>
                <p>3. {{ $t("TWOFA.DEC3") }}</p>
              </b-container>
              <template v-slot:modal-footer>
                <b-button
                  variant="outline-secondary"
                  v-on:click="modalClose('enableModal1')"
                >
                  {{ $t("COMMON.CANCEL") }}
                </b-button>
                <b-button variant="primary" v-on:click="openEnableModal2()">
                  {{ $t("COMMON.NEXT") }}
                </b-button>
              </template>
            </b-modal>

            <!-- ----------enable modal step 2------------- -->
            <b-modal
              ref="enableModal2"
              :title="$t('TWOFA.ENABLE_TITLE', { step: 2 })"
              @shown="onOtpModalShown('enable')"
              @hidden="onOtpModalHidden"
            >
              <b-container fluid>
                <b-row>
                  <b-col md="4">
                    <p>1. {{ $t("TWOFA.SCAN_DEC1") }}</p>
                    <p>2. {{ $t("TWOFA.SCAN_DEC2") }}</p>
                    <p>3. {{ $t("TWOFA.SCAN_DEC3") }}</p>
                    <p>4. {{ $t("TWOFA.SCAN_DEC4") }}</p>
                  </b-col>
                  <b-col md="8">
                    <img
                      :src="'data:image/png;base64,' + qrcodeData"
                      :alt="$t('AUTH.MFA_ENROLLMENT.QR_ALT')"
                      class="w-100"
                    />
                  </b-col>
                </b-row>

                <b-row class="my-4">
                  <b-col sm="12">
		<div class="otp-center">
                    <label class="d-block mb-2">{{ $t("TWOFA.CHALLENGE") }}:</label>

                    <!-- OTP INPUTS -->
                    <div class="otp-wrap" @paste.prevent="onOtpPaste">
                      <input
                        v-for="(d, idx) in otpDigits"
                        :key="'enable-' + idx"
                        :ref="'otp-' + idx"
                        class="otp-input"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        autocomplete="one-time-code"
                        maxlength="1"
                        :value="otpDigits[idx]"
                        @input="onOtpInput($event, idx)"
                        @keydown="onOtpKeydown($event, idx)"
                        @focus="onOtpFocus(idx)"
                        :aria-label="$t('TWOFA.OTP_DIGIT', { digit: idx + 1 })"
                      />
                    </div>

                    <div v-if="otpError" class="otp-error mt-2">
                      {{ $t("VALIDATION.REQUIRED_FIELD") }}
                    </div>

                    <!-- optional helper -->
                    <small class="text-muted d-block mt-2">
                      {{ $t("TWOFA.OTP_HINT") || "" }}
                    </small>
		</div>
                  </b-col>
                </b-row>
              </b-container>

              <template v-slot:modal-footer>
                <b-button
                  variant="outline-secondary"
                  v-on:click="modalClose('enableModal2')"
                >
                  {{ $t("COMMON.CANCEL") }}
                </b-button>
                <b-button variant="primary" v-on:click="enableTfa()">
                  {{ $t("COMMON.SAVE") }}
                </b-button>
              </template>
            </b-modal>
          </template>
        </KTPortlet>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Big, fast OTP entry */
.otp-center {
  display: flex;
  flex-direction: column;
  align-items: center;     /* centers label + row */
  width: 100%;
}

.otp-wrap--center {
  justify-content: center; /* centers the 6 boxes row */
}

.otp-wrap {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.otp-input {
  width: 52px;
  height: 56px;
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #d6d6d6;
  border-radius: 8px;
  outline: none;
}

.otp-input:focus {
  border-color: #3699ff; /* Metronic-ish primary */
  box-shadow: 0 0 0 3px rgba(54, 153, 255, 0.2);
}

.otp-error {
  color: #f64e60; /* Metronic danger-ish */
  font-size: 13px;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import { validationMixin } from "vuelidate";
import KTPortlet from "@/views/partials/content/Portlet.vue";
import { postRequest } from "@/api/request.js";
import JwtService from "@/common/jwt.service";

export default {
  mixins: [validationMixin],
  name: "twofa",
  components: {
    KTPortlet,
  },
  data: () => ({
    status: {
      selected: 0,
    },

    // OTP UI state
    otpDigits: ["", "", "", "", "", ""],
    otpMode: null, // "enable" | "disable"
    otpError: false,
    submittingOtp: false,

    qrcodeData: "",
    allowDisable: false,
    canConfigure: false,
  }),
  computed: {
    statusData: function () {
      const options = [{ name: this.$t("COMMON.ENABLED"), value: 1 }];
      if (this.allowDisable) options.unshift({ name: this.$t("COMMON.DISABLED"), value: 0 });
      return options;
    },
    isTfa: function () {
      return localStorage.isTfa == 1;
    },
    otpCode() {
      return this.otpDigits.join("");
    },
    otpComplete() {
      return this.otpDigits.every((d) => /^[0-9]$/.test(d));
    },
  },
  created() {
    postRequest({
      action: "get2fa",
      token: localStorage.id_token,
    }).then((res) => {
      if (res && res.returncode) {
        this.status.selected = res.returndata["2fa_enabled"];
        this.allowDisable = Number(res.returndata.ip_restricted_logins) === 1;
        this.canConfigure = res.returndata.enrollment_allowed === true;
      } else {
        this.makeToastVariant("danger", res.returndata);
      }
    });
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$t("MENU.TWOFA") }]);
  },
  methods: {

clearOtpAndRefocus() {
  this.otpDigits = ["", "", "", "", "", ""];
  this.otpError = false;
  this.$nextTick(() => this.focusOtp(0));
},
    /*  -----modal close------- */
    modalClose(modalRef) {
      this.resetOtp();
      this.$refs[modalRef].hide();
    },

    resetOtp() {
      this.otpDigits = ["", "", "", "", "", ""];
      this.otpError = false;
      this.submittingOtp = false;
      this.otpMode = null;
    },

    openModal() {
      if (this.status.selected == 1) {
        this.$refs["enableModal1"].show();
      } else {
        this.$refs["disableModal"].show();
      }
    },

    openEnableModal2() {
      postRequest({
        action: "enable_2fa",
        token: localStorage.id_token,
        step_link: "step0",
      }).then((res) => {
        if (res && res.returncode) {
          this.qrcodeData = decodeURIComponent(res.returndata.qr);
          this.$refs["enableModal2"].show();
          this.$refs["enableModal1"].hide();
        } else {
          this.makeToastVariant("danger", res.returndata);
        }
      });
    },

    // -------- OTP UX handlers --------
    onOtpModalShown(mode) {
      this.otpMode = mode; // "enable" or "disable"
      this.otpError = false;
      this.submittingOtp = false;
      this.otpDigits = ["", "", "", "", "", ""];

      this.$nextTick(() => {
        const el = this.$refs["otp-0"];
        // In Vue 2, refs in v-for can be arrays
        const input0 = Array.isArray(el) ? el[0] : el;
        if (input0 && input0.focus) input0.focus();
      });
    },

    onOtpModalHidden() {
      // Ensure state doesn’t leak between modals
      this.resetOtp();
    },

    onOtpFocus(idx) {
      // If user clicks into the middle while empty, keep focus at first empty slot
      const firstEmpty = this.otpDigits.findIndex((d) => d === "");
      if (firstEmpty !== -1 && idx > firstEmpty) {
        this.focusOtp(firstEmpty);
      }
    },

    focusOtp(idx) {
      this.$nextTick(() => {
        const el = this.$refs["otp-" + idx];
        const input = Array.isArray(el) ? el[0] : el;
        if (input && input.focus) input.focus();
        if (input && input.select) input.select();
      });
    },

    onOtpInput(e, idx) {
      const raw = (e && e.target && e.target.value) ? String(e.target.value) : "";
      const digit = raw.replace(/\D/g, "").slice(-1); // keep last digit only

      // update digit
      this.$set(this.otpDigits, idx, digit);
      this.otpError = false;

      // advance
      if (digit && idx < 5) {
        this.focusOtp(idx + 1);
      }

      // autosubmit once complete
      if (this.otpComplete) {
        this.autoSubmitOtp();
      }
    },

    onOtpKeydown(e, idx) {
      const key = e.key;

      // Backspace behavior: if empty, go back; else clear current
      if (key === "Backspace") {
        e.preventDefault();
        if (this.otpDigits[idx]) {
          this.$set(this.otpDigits, idx, "");
        } else if (idx > 0) {
          this.$set(this.otpDigits, idx - 1, "");
          this.focusOtp(idx - 1);
        }
        return;
      }

      // Left/Right navigation
      if (key === "ArrowLeft" && idx > 0) {
        e.preventDefault();
        this.focusOtp(idx - 1);
        return;
      }
      if (key === "ArrowRight" && idx < 5) {
        e.preventDefault();
        this.focusOtp(idx + 1);
        return;
      }

      // Only allow digits & basic keys
      if (
        key.length === 1 &&
        !/[0-9]/.test(key) &&
        key !== "Tab"
      ) {
        e.preventDefault();
      }
    },

    onOtpPaste(e) {
      const txt = (e.clipboardData && e.clipboardData.getData("text")) || "";
      const digits = String(txt).replace(/\D/g, "").slice(0, 6);

      if (!digits) return;

      const arr = digits.split("");
      for (let i = 0; i < 6; i++) {
        this.$set(this.otpDigits, i, arr[i] || "");
      }

      const nextIndex = Math.min(digits.length, 5);
      this.focusOtp(nextIndex);

      if (digits.length === 6) {
        this.autoSubmitOtp();
      }
    },

    autoSubmitOtp() {
      if (this.submittingOtp) return;
      if (!this.otpComplete) {
        this.otpError = true;
        return;
      }

      this.submittingOtp = true;

      // auto route based on modal
      if (this.otpMode === "disable") {
        this.disableTfa();
      } else if (this.otpMode === "enable") {
        this.enableTfa();
      }
    },

    // -------- API actions --------
    disableTfa() {
      if (!this.otpComplete) {
        this.otpError = true;
        this.submittingOtp = false;
        return;
      }

      postRequest({
        action: "disable_2fa",
        token: localStorage.id_token,
        twofa_code: this.otpCode,
      }).then((res) => {
        if (res.returncode) {
          this.makeToastVariant("success", res.returndata);
          JwtService.saveTfaState(0);
          this.$refs["disableModal"].hide();
        } else {
          this.makeToastVariant("danger", res.returndata);
	  this.clearOtpAndRefocus();
        }
      }).finally(() => {
        this.submittingOtp = false;
      });
    },

    enableTfa() {
      if (!this.otpComplete) {
        this.otpError = true;
        this.submittingOtp = false;
        return;
      }

      postRequest({
        action: "verify_2fa",
        token: localStorage.id_token,
        twofa_code: this.otpCode,
      }).then((res) => {
        if (res && res.returncode) {
          this.makeToastVariant("success", res.returndata);
          JwtService.saveTfaState(1);
          this.$refs["enableModal2"].hide();
        } else {
          this.makeToastVariant("danger", res.returndata);
	  this.clearOtpAndRefocus();
        }
      }).finally(() => {
        this.submittingOtp = false;
      });
    },

    /* ----notify---- */
    makeToastVariant(variant = null, msg) {
      let title = this.$t("COMMON.ERROR");
      if (variant == "success") {
        title = this.$t("COMMON.SUCCESS");
      }
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        toaster: "b-toaster-top-center",
        solid: true,
      });
    },
  },
};
</script>
